/* @flow */
// [stiffness, damping]
export default {
  noWobble: [170, 26], // the default
  gentle: [120, 14],
  wobbly: [180, 12],
  stiff: [210, 20],
};



/** WEBPACK FOOTER **
 ** D:/Github/react-motion/src/presets.js
 **/